const minin = {
  data() {
    return {
      // table高度默认没有tab--610，在Table组件中设置
      // 有一层tab的table高度--550，在table.js中设置
      // 有两层tab的table高度--500
      tableHeight: 500,
      formCtrl: [
        {
          label: '装货日期：',
          keyName: 'starttime',
          placeholder: '选择日期',
          type: 'date',
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { label: '装货日期', keyName: 'starttime', },
        { label: '卸货日期', keyName: 'edittime', },
      ],
      searchKeyOptions: [
        { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      baseParams: ['ischeck', 'isstatus'],
      btnloading: false,

      title: '导出过磅单',
      modalList: [],
      mform: {},
      mformCtrl: [
        {
          label: '卸货日期',
          keyName: 'edittime_list',
          type: 'dates',
        },
        {
          label: '卸货日期',
          keyName: 'edittime',
          type: 'daterange',
        },
        {
          label: '货物名称',
          keyName: 'name',
          placeholder: '请输入货物名称',
          type: 'text',
        },
        {
          label: '装货地址',
          keyName: 'coaddress',
          placeholder: '请输入装货地址',
          type: 'text',
        },
        {
          label: '卸货地址',
          keyName: 'enaddress',
          placeholder: '请输入卸货地址',
          type: 'text',
        },
      ],
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          ...this.ctrls.license
        },
      ],
    };
  },
  methods: {
    onClose() {
      this.mform = {};
      this.modalSearchForm = {};

      if (this.$refs["carlist"] && this.$refs["carlist"].clearChecked) {
        this.$refs["carlist"].clearChecked();
      }
    },
    onModalFormChange({ key, value }) {
      // console.log(key, value);
      this.mform[key] = value;
      if (key === 'edittime_list') {
        if (value) {
          this.$set(this.mform, 'edittime', null);
        }
        // this.mformCtrl.map(v => {
        //   if (v.keyName === 'edittime') {
        //     v.disabled = !!value;
        //   }
        // });
      } else if (key === 'edittime') {
        if (value) {
          this.$set(this.mform, 'edittime_list', null);
        }
      }
      console.log({ ...this.mform });
      // console.log([...this.mformCtrl]);
    },

    onSearchFormChange({ key, value }) {
      // console.log(key, value);
      this.modalSearchForm[key] = value;
      // console.log({ ...this.modalSearchForm });
    },
    onModalSearchReset() {
      this.modalSearchForm = {};
      this.getCars();
    },
    getCars() {
      this.cars = [];
      let url = `car/carlist`;
      const params = {
        userid: this.user.id
      };
      const object = this.modalSearchForm;
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key) && object[key]) {
          params[key] = object[key];
        }
      }
      console.log(url, params);
      this.post(
        url,
        params,
        ({ data }) => {
          if (data && data.length) {
            this.modalList = data;
          }
        },
        err => {
          console.log(err);
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！'
          });
        }
      );
    },

    onCheckChange(v) {
      // console.log(v);
      if (v && v.length) {
        this.mform.car_list = [...v];
      }
    },
    onModalSubmit() {
      console.log('mform', { ...this.mform });

      this.btnloading = true;
      let url = `order/expicture`;
      const params = {
        // userid: this.user.id,
        ...this.mform
      };

      // console.log(url, params)

      this.post(
        url,
        params,
        res => {
          this.btnloading = false;
          // console.log(res)
          const { msg, url } = res;
          if (msg === 'success' && url) {
            console.log(url);
            var link = document.createElement('a');
            link.href = url;
            // link.download = '过磅单'
            link.click();

            this.hideDialog();
          } else {
            this.$message({
              message: msg || '导出失败，请稍后再试！',
              type: 'error'
            });
          }
        },
        err => {
          console.log(err);
          this.$message({
            type: 'error',
            message: '获取数据失败，请稍后重试！'
          });
        }
      );
    },

    onModalCancel() {
      // this.form.order_num = null
      this.hideDialog();
    },

    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.isMark = v.is_mark + ''
          return obj
        })
      }
      console.log(this.tableData)
    },
    toggleMark({ id, is_mark }) {
      let url = `order/mark`;
      const params = {
        userid: this.user.id,
        id,
        is_mark: is_mark == 1 ? 0 : 1,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    getExport() {
      this.btnloading = true
      let url = `order/expicture`;
      const params = {
        // userid: this.user.id,
        order_list: []
      }
      if (this.tableData && this.tableData.length) {
        this.tableData.map(v => {
          params.order_list.push(v.id)
        })
      }
      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          link.download = '过磅单'
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    delete(order_num) {
      console.log('order_num', order_num)
      this.$prompt('删除原因', '确认删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.delReq(order_num, value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(order_num, del_desc) {
      this.loading = true
      let url = `order/delorder`;
      const params = {
        userid: this.user.id,
        order_num,
        del_desc,
      }

      const mod = this.$route.path.includes('/nocontract') ? 'order' : 'contract_order'
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': mod,
      }
      // console.log('url', url)
      // console.log('params', { ...params })
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    this.getList()
  },
}

export default minin